import { Navigate, useRoutes } from 'react-router-dom';
import { routes } from '@routes';
import DashboardLayout from '@components/ui/layouts/dashboard';
import { useAuth } from '@context/auth';
import { ProtectedRoute } from '@components/routes';
import { DashboardPage } from './pages/dashboard';
import { IncentivesPage } from './pages/dashboard/incentives';
import { ProfilePage } from './pages/dashboard/profile';
import { SettingsPage } from './pages/dashboard/settings';
import { NotFound } from './pages/not-found';
import { LoginPage } from './pages/login';
import { ForgotPasswordPage } from './pages/forgot-password';
import { SignUpPage } from './pages/signup';
import { ResetPasswordPage } from './pages/reset-password';
import { AddIncentivePage } from './pages/dashboard/incentives/add';
import { EditIncentivePage } from './pages/dashboard/incentives/edit';
import { ImpersonatorPage } from './pages/impersonator';

export default function Router() {
  const { isAuthenticated, isImpersonator } = useAuth();
  const router = useRoutes([
    {
      children: [
        { element: <DashboardPage />, index: true, path: routes.dashboard },
        {
          element: <IncentivesPage />,
          path: routes.incentives,
        },
        {
          element: <AddIncentivePage />,
          path: routes.addIncentive,
        },
        {
          element: <EditIncentivePage />,
          path: routes.editIncentivePath,
        },
        { element: <ProfilePage />, path: routes.profile },
        { element: <SettingsPage />, path: routes.settings },
      ],
      element: (
        <ProtectedRoute isAllowed={isAuthenticated} redirectPath={routes.login}>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      path: routes.dashboard,
    },
    {
      element: (
        <ProtectedRoute
          isAllowed={isImpersonator}
          redirectPath={routes.dashboard}
        >
          <ImpersonatorPage />
        </ProtectedRoute>
      ),
      path: routes.impersonator,
    },
    {
      element: <NotFound />,
      path: routes.notFound,
    },
    {
      element: <ForgotPasswordPage />,
      path: routes.forgotPassword,
    },
    {
      element: <LoginPage />,
      path: routes.login,
    },
    {
      element: <ResetPasswordPage />,
      path: routes.resetPassword,
    },
    {
      element: <SignUpPage />,
      path: routes.signUp,
    },
    {
      element: <Navigate to={routes.dashboard} replace />,
      path: '/',
    },
    {
      element: <Navigate to={routes.notFound} replace />,
      path: '*',
    },
  ]);

  return router;
}
